import React, { Component } from "react";

function clamp(v, min, max) {
  return Math.max(min, Math.min(max, v));
}

export default class ImageCropper extends Component {
  constructor(props) {
    super(props);
    this.imgRef = React.createRef();
    this.state = { url: URL.createObjectURL(props.file), natural: null, display: null, sel: null, drag: null };
  }

  componentWillUnmount() {
    if (this.state.url) URL.revokeObjectURL(this.state.url);
  }

  onImgLoad = () => {
    const img = this.imgRef.current;
    const display = { w: img.clientWidth, h: img.clientHeight };
    const natural = { w: img.naturalWidth, h: img.naturalHeight };
    // Square selection (1:1), centered, sized to 60% of the shorter side.
    const side = Math.round(Math.min(display.w, display.h) * 0.6);
    this.setState({
      natural,
      display,
      sel: { x: Math.round((display.w - side) / 2), y: Math.round((display.h - side) / 2), w: side, h: side },
    });
  };

  startDrag = (mode, e) => {
    e.preventDefault();
    e.stopPropagation();
    this.setState({ drag: { mode, startX: e.clientX, startY: e.clientY, orig: { ...this.state.sel } } });
  };

  onMove = e => {
    const { drag, display } = this.state;
    if (!drag || !display) return;
    const dx = e.clientX - drag.startX, dy = e.clientY - drag.startY, MIN = 20;
    const o = drag.orig;

    // Move: shift the square within the image bounds (size unchanged).
    if (drag.mode === "move") {
      const x = clamp(o.x + dx, 0, display.w - o.w);
      const y = clamp(o.y + dy, 0, display.h - o.h);
      this.setState({ sel: { x, y, w: o.w, h: o.h } });
      return;
    }

    // Corner resize: keep a perfect square (1:1). The opposite corner stays fixed,
    // and the side grows/shrinks with the drag, clamped to the image bounds.
    let grow, maxSide;
    if (drag.mode === "se") { grow = Math.max(dx, dy); maxSide = Math.min(display.w - o.x, display.h - o.y); }
    else if (drag.mode === "nw") { grow = Math.max(-dx, -dy); maxSide = Math.min(o.x + o.w, o.y + o.h); }
    else if (drag.mode === "ne") { grow = Math.max(dx, -dy); maxSide = Math.min(display.w - o.x, o.y + o.h); }
    else { grow = Math.max(-dx, dy); maxSide = Math.min(o.x + o.w, display.h - o.y); } // sw

    const side = clamp(o.w + grow, MIN, maxSide);
    let x = o.x, y = o.y; // se anchors at top-left
    if (drag.mode === "nw") { x = o.x + o.w - side; y = o.y + o.h - side; }
    else if (drag.mode === "ne") { y = o.y + o.h - side; }
    else if (drag.mode === "sw") { x = o.x + o.w - side; }

    this.setState({ sel: { x, y, w: side, h: side } });
  };

  endDrag = () => {
    if (this.state.drag) this.setState({ drag: null });
  };

  confirm = () => {
    const { natural, display, sel } = this.state;
    const sx = (sel.x / display.w) * natural.w, sy = (sel.y / display.h) * natural.h;
    const sw = (sel.w / display.w) * natural.w, sh = (sel.h / display.h) * natural.h;
    const canvas = document.createElement("canvas");
    canvas.width = Math.max(1, Math.round(sw));
    canvas.height = Math.max(1, Math.round(sh));
    canvas.getContext("2d").drawImage(this.imgRef.current, sx, sy, sw, sh, 0, 0, canvas.width, canvas.height);
    const type = this.props.file.type || "image/png";
    canvas.toBlob(
      blob => {
        const cropped = new File([blob], this.props.file.name || "logo.png", { type });
        this.props.onConfirm(cropped);
      },
      type,
      0.92
    );
  };

  render() {
    const { url, sel } = this.state;
    const L = this.props.labels || {};
    return (
      <div className="pt-cropper-overlay" role="dialog" aria-modal="true">
        <div className="pt-cropper" onPointerMove={this.onMove} onPointerUp={this.endDrag} onPointerLeave={this.endDrag}>
          <div className="pt-cropper-stage">
            <img ref={this.imgRef} src={url} onLoad={this.onImgLoad} className="pt-cropper-img" alt="" draggable={false} />
            {sel && (
              <div
                className="pt-cropper-sel"
                style={{ left: sel.x, top: sel.y, width: sel.w, height: sel.h }}
                onPointerDown={e => this.startDrag("move", e)}>
                {["nw", "ne", "sw", "se"].map(hd => (
                  <span key={hd} className={"pt-cropper-handle pt-cropper-handle-" + hd} onPointerDown={e => this.startDrag(hd, e)} />
                ))}
              </div>
            )}
          </div>
          <div className="pt-cropper-actions">
            <button type="button" className="mp-toggle-btn" onClick={this.props.onCancel}>
              {L.cropCancel || "Cancel"}
            </button>
            <button type="button" className="mp-save-btn" onClick={this.confirm}>
              {L.cropConfirm || "Crop"}
            </button>
          </div>
        </div>
      </div>
    );
  }
}
